export default __webpack_public_path__ + "static/media/left_flatFoot.0da813ef.png";